export function mergeFunctions(...funcs: Function[]) {
	return function (...args: any[]) {
		funcs.filter((fn) => !!fn).forEach((fn) => fn?.(...args));
	};
}
